<template>
  <AppTab v-model="currentTab" :tabs="tabs" />

  <div class="qr-img-wrap">
    <img :src="`${qrImageUrl}`" alt="qr-image" />
  </div>

  <div class="link-input">
    <span>{{ linkUrl }}</span>
    <button type="button" class="s-btn primary-bg-btn" @click="copyLink">
      {{ t('label_copy') }}
    </button>
  </div>
</template>

<script setup lang="ts" generic="T = unknown">
import { computed, ref } from 'vue';

import AppTab from '@/components/domains/mobile/common/AppTab.vue';
import { usePopupStore } from '@/stores/popup';
import { AppTabButton } from '@/types/components';

const props = withDefaults(
  defineProps<{
    payload?: T;
  }>(),
  {
    payload: undefined,
  }
);

const { t } = useI18n();

const popupStore = usePopupStore();

const currentTab = ref<string>('guest');

const qrImageUrl = computed(() => {
  return currentTab.value === 'guest' ? props.payload?.guestQRCodeImageUrl : props.payload?.employeeQRCodeImageUrl;
});
const linkUrl = computed(() => {
  return currentTab.value === 'guest' ? props.payload?.guestLinkUrl : props.payload?.employeeLinkUrl;
});

const tabs: AppTabButton[] = [
  { label: 'label_for_guest', value: 'guest' },
  { label: 'label_for_host', value: 'host' },
] as const;

const copyLink = () => {
  navigator.clipboard.writeText(linkUrl.value);
  popupStore.openToast(t('copied'));
};
</script>

<style scoped lang="scss">
.qr-img-wrap {
  padding: 1rem;
  text-align: center;

  img {
    width: 100%;
    max-width: 200px;
    height: 100%;
    object-fit: contain;
  }
}
.primary-bg-btn {
}
</style>
